import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import { Col, Container, Row } from 'react-bootstrap';

import './header.scss';

export default ({
  title,
  field_organisation,
  field_organisation_icon,
  ...rest
}) => {
  const Icon = (
    <Col xs={12} md={6} className={`d-flex order-1 order-md-2`}>
      {/* <div
        className={`cover-xy d-md-none`}
        style={{
          backgroundColor: '#FFFFFF',
        }}
      /> */}
      {field_organisation_icon.relationships &&
      field_organisation_icon.relationships.field_media_image
        .localFile.childImageSharp ? (
        <GatsbyImage
          image={{
            ...field_organisation_icon.relationships.field_media_image
              .localFile.childImageSharp.gatsbyImageData,
          }}
          imgStyle={{ objectFit: 'contain' }}
          loading="eager"
          alt={field_organisation.title} />
      ) : (
        <img
          alt={field_organisation.title + ' case study logo'}
          src={
            field_organisation_icon.relationships.field_media_image
              .localFile.publicURL
          }
          // className={classNames('svg', {
          //   // fluid: data.img.fluid,
          // })}
        />
        // <svg>
        //   <image
        //     href={
        //       field_organisation_icon.relationships.field_media_image
        //         .localFile.publicURL
        //     }
        //     x="0"
        //     y="0"
        //     width="100%"
        //     height="100%"
        //     preserveAspectRatio="xMinYMin slice"
        //   />
        // </svg>
      )}
    </Col>
  );

  const Title = (
    <Col xs={12} md={6} className={`d-flex order-2 order-md-1`}>
      <div
        className={`cover-xy d-md-none`}
        style={{ backgroundColor: '#FAFAFA' }}
      />
      <Row>
        <Col xs={12}>
          <h1>{title}</h1>
          <h3> {field_organisation.title} </h3>
        </Col>
      </Row>
    </Col>
  );

  return (
    <section {...rest}>
      <div
        className={`cover-xy--50-100 d-none d-md-block`}
        style={{ backgroundColor: '#FAFAFA' }}
      />
      <Container>
        <Row>
          {Icon}
          {Title}
        </Row>
      </Container>
    </section>
  );
};
